import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ScheduleAction, ScheduleTranslator } from '@cbridge-packages/schedule';

type IDependencies = IClientApiDependencySegment;

export const loadScheduleListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleAction.loadList.started),
  mergeMap((params) => {
    return dependencies.api.getScheduleList().pipe(
      mergeMap((response) => {
        const result = (response.schedules ?? []).map(ScheduleTranslator.fromApi);

        return [
          ScheduleAction.loadList.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          ScheduleAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
